<template>
  <div class="auth-box"  :style="{ height: height }">
    <div class="auth-content">
      <img
        class="logo"
        src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/78eb1e7156ada066d35d380f7e409abc.png"
        alt=""
      />
      <div class="name">立吉答题欢迎你</div>
      <button class="login-btn" @click="loginClick">立即登录</button>
    </div>
    <div class="contact" @click="contact">
      联系客服反馈
    </div>
  </div>
</template>
<script>
export default {
  props: ['height', 'ableContact'],
  data() {
    return {};
  },
  methods: {
    contact() {
      if(this.ableContact) {
        _ZHINI({ action: 'showPanel' })
        // this.$emit('handleContact')
      }
    },
    loginClick() {
      this.$emit('loginClick')
    }
  }
};
</script>

<style lang="scss" scoped>
.auth-box {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: #ffffff;
  text-align: center;
  width: 100%;
}
.login-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  background: #1890ff;
  width: 150px;
  height: 42px;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  font-size: 17px;
}
.auth-box .logo {
  width: 80px;
  height: 80px;
} 
.auth-box .name {
  font-weight: bold;
  text-align: center;
  margin: 0 0 20px;
}
.auth-box .contact {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  color: #999999;
  font-size: 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/auth.vue